// extracted by mini-css-extract-plugin
module.exports = {"container":"tag-display_container__H6HLJ","tag":"tag-display_tag__S3L_f","tagText":"tag-display_tagText__fw4Y5"};